import { Link } from "react-router-dom";
import { Chapter, Reveal } from "@/components/motion";
import { CONTACT } from "@/data/site";

const COPY = {
  privacy: {
    label: "Legal",
    title: "Privacy Policy",
    paras: [
      "Formcore Constructions respects the privacy of everyone who contacts us. Personal information submitted through this website — such as your name, company, phone number and email address — is collected solely for the purpose of responding to your workforce enquiry and managing our business relationship with you.",
      "We do not sell, rent or disclose your personal information to third parties except where required by law or where necessary to deliver the services you have requested. Enquiry information is stored securely and accessed only by authorised Formcore management.",
      "You may request access to, or correction of, the personal information we hold about you at any time by contacting us using the details below.",
    ],
  },
  terms: {
    label: "Legal",
    title: "Terms & Conditions",
    paras: [
      "The content of this website is provided for general information about Formcore Constructions and the workforce solutions we offer. It does not constitute a quotation, offer or agreement for the supply of personnel.",
      "All workforce engagements are governed by separate written terms agreed between Formcore Constructions and the client. While we take care to keep website content accurate and current, Formcore Constructions accepts no liability for any loss arising from reliance on information presented on this website.",
      "All content, branding and imagery on this website remain the property of Formcore Constructions and may not be reproduced without written permission.",
    ],
  },
};

export default function Legal({ kind }) {
  const copy = COPY[kind] || COPY.privacy;
  return (
    <div data-testid={`legal-${kind}-page`}>
      <section className="relative overflow-hidden bg-navy">
        <div className="absolute inset-0 bg-blueprint-dark opacity-30" />
        <div className="relative z-10 mx-auto max-w-7xl px-6 pb-16 pt-40">
          <Chapter index="—" label={copy.label} dark />
          <Reveal delay={0.1}>
            <h1 className="mt-8 font-heading text-4xl font-extrabold tracking-tight text-white sm:text-5xl">{copy.title}</h1>
          </Reveal>
        </div>
        <div className="relative z-10 h-1.5 w-full bg-gold" />
      </section>
      <section className="bg-white py-20 lg:py-24">
        <div className="mx-auto max-w-3xl px-6">
          {copy.paras.map((p, i) => (
            <Reveal key={i} delay={i * 0.05}>
              <p className="mb-6 text-base leading-relaxed text-charcoal/75">{p}</p>
            </Reveal>
          ))}
          <Reveal delay={0.15}>
            <p className="mt-10 border-t border-navy/10 pt-8 text-sm text-charcoal/60">
              Questions? Contact us at{" "}
              <a href={CONTACT.emailHref} className="font-semibold text-navy underline decoration-gold underline-offset-4">
                {CONTACT.email}
              </a>{" "}
              or call {CONTACT.phone}. <Link to="/" className="ml-2 font-semibold text-navy underline decoration-gold underline-offset-4">Return home</Link>
            </p>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
